import Loadable from '../../components/loadable';

const ManageWebsiteWidgets = Loadable({
  loader: () => import('../../pages/manage_website/widgets'),
});

angular.module('gym').value('ManageWebsiteWidgets', ManageWebsiteWidgets);
